<script>
export default {
    name: 'forms',
    methods: {
        jumpToError () {
            this.$nextTick(() => {
                let form = this.$el.querySelector('#form');
                if (form) {
                    let elem = form.getElementsByClassName('has-error');
                    if (elem.length > 0) {
                        elem[0].focus();
                    }
                };
            });
        },
        jumpToFirstInput () {
            this.$nextTick(() => {
                let form = this.$el.querySelector('#form');
                if (form) {
                    form.getElementsByTagName('input')[0].focus();
                };
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/mixins/forms.vue